import * as React from 'react';
import { ImportDataService } from '../../services';
import { BaseRouteProps } from '../../interfaces';

export class SettingsView extends React.Component<BaseRouteProps<{ id: number }>, any> {
    private importDataService = new ImportDataService(this.props.notificationService);

    render() {
        return <div onClick={(e) => this.calc()}> Calculate</div>;
    }

    calc() {
        this.importDataService.Calc();
    }
}


// WEBPACK FOOTER //
// ./src/components/settings/SettingsView.tsx